import React, { useMemo } from "react"
import { Helmet } from "react-helmet-async"
import { useTranslation } from "react-i18next"

type SeoProps = {
	title?: string
}

export const Seo: React.FC<SeoProps> = ({ title }) => {
	const subdomain = document.domain.split(".")
	const { t } = useTranslation()

	const defaultTitle = useMemo(() => {
		if (subdomain.includes("bicycode")) {
			return "Bicycode | " + t("seo.title")
		}

		if (subdomain.includes("mfc")) {
			return "MFC | " + t("seo.title")
		}

		return t("seo.title")
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [subdomain])

	return (
		<Helmet>
			<title>{title ? title : defaultTitle}</title>
		</Helmet>
	)
}
